import api from '@/api'
import { BaseModalProps } from '@/components/modals/base-modal/base-modal'
import FormModal from '@/components/modals/FormModal'
import LoadingButton from '@mui/lab/LoadingButton'
import {
  Button,
  DialogContent,
  DialogContentText,
  Input,
  Typography,
} from '@mui/material'
import React from 'react'
import { toast } from 'react-toastify'

interface FileUploaderModalProps extends BaseModalProps {
  contextType?: 'customer' | 'deal' | 'car' | 'report' | 'user'
  contextId?: string | number
  multiple?: boolean
  acceptedTypes?: string // e.g. "image/*,.pdf"
  title?: string
}

const FileUploaderModal: React.FC<FileUploaderModalProps> = ({
  isOpen,
  onClose,
  contextType,
  contextId,
  multiple = true,
  acceptedTypes,
  title = 'העלאת קבצים',
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [selectedFiles, setSelectedFiles] = React.useState<FileList | null>(
    null,
  )

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFiles(event.target.files)
    }
  }

  const onSubmit = async () => {
    if (!selectedFiles || selectedFiles.length === 0) {
      toast.error('אנא בחר קבצים להעלאה')
      return
    }

    setIsLoading(true)
    try {
      const formData = new FormData()

      Array.from(selectedFiles).forEach((file) => {
        formData.append(`file`, file)
      })

      if (contextType && contextId) {
        formData.append(contextType, contextId.toString())
      }

      const response = await api.post('files/', {
        ...Object.fromEntries(formData.entries()),
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      const filesCount = selectedFiles.length
      const fileWord = filesCount === 1 ? 'קובץ' : 'קבצים'
      toast.success(`${filesCount} ${fileWord} הועלו בהצלחה`)

      setSelectedFiles(null)
      onClose()
    } catch (error) {
      toast.error('שגיאה בהעלאת הקבצים')
    } finally {
      setIsLoading(false)
    }
  }


  const getSelectedFilesText = () => {
    if (!selectedFiles || selectedFiles.length === 0) return ''
    const count = selectedFiles.length
    const fileWord = count === 1 ? 'קובץ נבחר' : 'קבצים נבחרו'
    return `${count} ${fileWord}`
  }

  return (
    <FormModal
      onSubmit={onSubmit}
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <>
          <Button onClick={onClose}>ביטול</Button>
          <LoadingButton loading={isLoading} type="submit">
            העלה
          </LoadingButton>
        </>
      }
    >
      <DialogContent>
        <DialogContentText>{title}</DialogContentText>
        <Input
          type="file"
          inputProps={{
            multiple: multiple,
            accept: acceptedTypes,
          }}
          onChange={handleFileChange}
          fullWidth
          required
        />
        {selectedFiles && (
          <Typography variant="caption" sx={{ mt: 1 }}>
            {getSelectedFilesText()}
          </Typography>
        )}
      </DialogContent>
    </FormModal>
  )
}

export default FileUploaderModal
